import { axios } from '@/plugins/axios';
import { ApiStatus } from './types';

export default async function getApiStatus(): Promise<ApiStatus> {
    return axios.get('/api/status');
}
